import { Path } from 'msw';

const baseUrl = 'https://jest.trukt.io';

export const mockTruktTmsApiUrl = (path: string): Path => {
  return new URL(path, baseUrl).toString();
};
